import { render, staticRenderFns } from "./ModalPaper.vue?vue&type=template&id=506c682f&scoped=true"
import script from "./ModalPaper.vue?vue&type=script&lang=js"
export * from "./ModalPaper.vue?vue&type=script&lang=js"
import style0 from "./ModalPaper.vue?vue&type=style&index=0&id=506c682f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c682f",
  null
  
)

export default component.exports